import React from 'react';
import Slider from '../Slider';


const WhatWeDo = () => {
       
          return (
                    <div className='bg-white'>
                                                  <div class="card  justify-center mx-auto">
  <div class="card-body m-40">
    {/* <h2 class="card-title text-center text-4xl">We believe in making the best work,and being the best to work with</h2> */}
    
    <p className='text-center text-5xl font-semi-bold text-black'>We use the power of design and technology to solve complex problems and transform business</p>
    {/* <p className='text-center text-4xl font-bold text-black'>complex problems and transform business</p> */}
    <button className='btn btn-active  m-6 bg-black text-white mx-auto rounded-full text-center justify-items-center justify-center align-middle'>Our Work</button>


    
  </div>
</div>
                              {/* <div class="hero min-h-screen bg-base-200 text-black">
  <div class="hero-content text-center">
    <div class="max-w-md">
      <p class="py-6 text-3xl font-bold">We use the power of design and technology to solve complex problems and transform business</p>
      <button className='btn btn-active  m-12 bg-black text-white mx-auto text-center justify-items-center justify-center align-middle'>Our Work</button>
    </div>
  </div>
</div> */}
                              
                              {/* <div className='justify-center bg-white m-5'>
                              <h3 className='text-center font-bold text-4xl '>We use the power of design and technology to solve </h3>
                              <h3 className='text-center font-bold text-4xl'>complex problems and transform business</h3>
                              <div className='mx-auto text-center justify-items-center justify-center align-middle'>
          <button className='btn btn-active  m-12 bg-black text-white mx-auto text-center justify-items-center justify-center align-middle'>Our Work</button>
</div>
                              </div> */}
                              <div className=' grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 '>
                              <div class="card w-96 bg-base-100 mx-auto ">
  <div class="card-body">
    <h2 class="card-title text-black">Brand & Communication Innovation</h2>
    <p className='font-serif text-1xl ' >We are a collaborative partner to businesses seeking transformation and growth. From strategic frameworks to targeted communications to design systems, we create powerful tools that propel brands forward and build influence.</p>
    
  </div>
</div>
<div class="card w-96 bg-base-100 mx-auto">
  <div class="card-body">
    <h2 class="card-title text-black">Product & Service Innovation</h2>
    <p className='font-serif text-1xl mt-2'>We concept, design, and deliver best-in-class products and services. Beyond websites and applications, we make interactive environments and deliver innovative user experiences.</p>
   
  </div>
</div>
                              </div>
                              <div className='m-36'>
                              <h1 className='text-center font-semi-bold text-4xl text-black align-middle justify-center'>As a full-service partner, we strategically connect your brand and communications to your products and services. We have the greatest impact when you hire us to do both.</h1>
                              {/* <h1 className='text-center font-bold text-4xl text-black'> We have the greatest impact when you hire us to do both.</h1> */}
                              <div className='mx-auto text-center justify-items-center justify-center align-middle'>
          <button className='btn btn-active rounded-full bg-black text-white mx-auto m-5 text-center justify-items-center justify-center align-middle'>Contact us</button>
</div>
                              </div>
                              <div class="carousel w-full mt-20">
  <div id="slide1" class="carousel-item relative w-full">
    <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" class="w-full" />
    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide4" class="btn btn-circle">❮</a> 
      <a href="#slide2" class="btn btn-circle">❯</a>
    </div>
  </div> 
  <div id="slide2" class="carousel-item relative w-full">
    <img src="https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" class="w-full" />
    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide1" class="btn btn-circle">❮</a> 
      <a href="#slide3" class="btn btn-circle">❯</a>
    </div>
  </div> 
  <div id="slide3" class="carousel-item relative w-full">
    <img src="https://images.unsplash.com/photo-1499754162586-08f451261482?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" class="w-full" />
    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide2" class="btn btn-circle">❮</a> 
      <a href="#slide4" class="btn btn-circle">❯</a>
    </div>
  </div> 
  <div id="slide4" class="carousel-item relative w-full">
    <img src="https://images.unsplash.com/photo-1536924940846-227afb31e2a5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=866&q=80" class="w-full" />
    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
      <a href="#slide3" class="btn btn-circle">❮</a> 
      <a href="#slide1" class="btn btn-circle">❯</a>
    </div>
  </div>
</div>


<div>
<h1 className='text-center font-semi-bold text-4xl text-black m-60'>We are equal parts creative agency, engineering firm, and consultancy. Our approach draws the best elements of each to deliver exceptional work. </h1>
</div>
<div>
<div class="card card-side bg-base-100 ">
  <figure><img className='' src="https://images.prismic.io/instrument-v5/90185ceb-7a82-44b4-81af-11b622f9f86e_process-one-flipped.jpg?auto=compress,format&w=1920" alt="Movie"></img></figure>
  <div class="card-body mr-28">
    <h2 class="card-title">Insight Driven</h2>
    <p>We use the power of research and data to uncover insights that lead to transformational change.</p>
  
    <h2 class="card-title">User Centric</h2>
    <p>We create experiences that improve our collective human experience.</p>
  
    <h2 class="card-title">Systematically Tested</h2>
    <p>We validate our solutions by creating testable experiments that produce exceptional outcomes.</p>
  
  
    <h2 class="card-title">Financially Impactful</h2>
    <p>We deliver work that has immediate, substantial, and sustained impact on your bottom line. </p>
  
  </div>
</div>
</div>
<div className='hover:bg-black hover:text-white pt-8'>
          <div>
          <h1 className='text-center text-4xl p-8 font-bold text-white'>Lately at Instrument</h1>
          </div>
        
<div  className=' grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-28 '>
<div className="card   ">
  <figure><img className='hover:bg-black' src="https://images.prismic.io/instrument-v5/1dfdc110-6561-4916-99fa-7cd74dcb2542_On-Air-5.jpg?auto=compress,format&w=1920" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">On Centering Voices of Users When Building Customer Experiences</h2>
    <p>In this episode, Jessica Hartley VP of Strategy and your host, is joined by Miasha Nakahara, Associate Creative Director, Jamal Qutub, Associate Director of Visual Craft, and Ramona Todoca, Associate Creative Director, to discuss what it means to be a diverse workforce of thoughtful makers and creators, who are building the bridges between brands and consumers.</p>
  
  </div>
</div>
<div className="card ">
  <figure><img className='mt-28' src="https://images.prismic.io/instrument-v5/351d2210-cc57-4b91-91ab-f88b6f3c3d21__on-air-3.png?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">On Air: On the importance of looking back before looking ahead</h2>
    <p>In this special episode of On Air, Jessica Hartley, VP of Strategy, is joined by Nishat Akhtar, AVP of Creative, and Leon Anderson, Executive Producer. They explore all that’s happened within the last six months, the reality of showing up every day as a BIPOC employee in Corporate America, and their future vision for the diversity, equity, and inclusion commitments that our organization and others made last year. We appreciate the honesty and energy with which these participants engaged in this episode.</p>

  </div>
</div>
</div>
<div  className=' grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 m-32 gap-28 '>
<div className="card   ">
  <figure><img className='h-' src="https://images.prismic.io/instrument-v5/e0863527-81fa-4e02-9b82-51c32dc5a907__onair-elvis-benicio.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">On Anti-racism and Accountability</h2>
    <p>Our VP of strategy, Jessica Hartley, is joined by creative director, Nishat Akhtar, strategy director, Ravi Mongia, and executive producer, Leon Anderson, to discuss how industries can deliver transformational change for Black professionals and the steps Instrument is taking to become more anti-racist.</p>
  
  </div>
</div>
<div className="card   ">
  <figure><img src="https://images.prismic.io/instrument-v5/2d85e7fd-6b11-4412-8b66-aeb5e6d7885e_on-air-artwork.jpg?auto=compress,format&w=1280" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">On Racism and Bias in Research</h2>
    <p>Our VP of strategy, Jessica Hartley, is joined by Accenture Senior Research Principal, Tchicaya Robertson, Beacon Raconteur Founder and Strategic Researcher, Leslie Marable, Instrument Research and Testing Strategist, Morgan Rose, and Instrument Strategy and Research Director, John Whaley to discuss how industries can mitigate racism and bias in research, how we can better approach research and what that research ultimately impacts.</p>

  </div>
</div>
</div>
<div className='bg-white pt-28 hover:bg-black hover:text-white'>
<h1 class="text-6xl font-bold text-center ">Build . Grow . Serve</h1>
<p className='text-center text-4xl  p-20 text-blak'>If your organization is interested in a pro bono partnership that serves to support Black communities, fight prejudice, or pursue a more just and inclusive future for all people, we want to hear from you.</p>
<div className='mx-auto text-center justify-items-center justify-center align-middle'>
          <button className='btn btn-active  rounded-full bg-white text-black mx-auto text-center justify-items-center justify-center align-middle'>Learn More</button>
</div>
</div>
</div>

<div className='mt-20'>
          <h1 className='text-center  font-bold text-5xl m-10'>Our Services</h1>
          <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 ml-32 gap-32 mt-20'>
          <div class="card card-compact w-96 bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=884&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">Brand</h2>
    
  <li>Positioning</li>
  <li>Identity</li>
  <li>Naming</li>
  <li>Voice and Tone</li>
  <li>Guidelines</li>
  <li>Design Systems</li>
  <li>Visual Centers</li>
  <li>Playbooks</li>

  </div>
</div>
          <div class="card card-compact w-96 bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">Engineering</h2>
   <li>Technical Architecture</li>
   <li>Technical Discovery</li>
   <li>Website Development</li>
   <li>Application Development</li>
   <li>Prototyping</li>
   <li>Quality Assurance</li>
   <li>Data Architecture</li>
   <li>CMS Implementation</li>
   
  </div>
</div>
          <div class="card card-compact w-96 bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1457433575995-8407028a9970?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">Digital Experience</h2>
   <li>Websites</li>
   <li>ios & Android Apps</li>
   <li>AR/VR Installations & POS</li>
   <li>Vision & Roadmapping</li>
   <li>Service Design</li>
   <li>Cx</li>
   
  </div>
</div>
          <div class="card card-compact w-96 bg-base-100 ">
  <figure><img src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" alt="Shoes" /></figure>
  <div class="card-body">
    <h2 class="card-title">Marketing</h2>
    <li>Communication Planning</li>
    <li>Campaigns</li>
    <li>Social Media</li>
    <li>SEO/SEM</li>
    <li>Event Measurements</li>
    <li>Photography and art</li>
    <li>Post Production</li>
    <li>Copywriting and Ediitorial</li>
    

  </div>
</div>
          </div>
</div>
{/* <Slider></Slider> */}
<div className='mt-32 '>
                              <h1 className='text-center font-semi-bold text-4xl text-black'>Curious about how all of this comes to life? </h1>
                              <h1 className='text-center font-semi-bold text-4xl text-black'>Explore some case studies.</h1>
                              <div className='mx-auto text-center justify-items-center justify-center align-middle'>
                              <button className='btn btn-active rounded-full m-2 bg-black text-white mx-auto text-center justify-items-center justify-center align-middle'>Get in Touch</button>
          {/* <button className='btn btn-active  m-4 bg-black text-white mx-auto text-center justify-items-center justify-center align-middle'>Our Work</button> */}
</div>
                              </div>
                    </div>
               
          );
};

export default WhatWeDo;